// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O9Wzn","colBig":"styles_colBig__3xYwD","colSmall":"styles_colSmall__qYbcj","shopifyNameWrapper":"styles_shopifyNameWrapper__20gPz"};